
import { supabase } from '@/integrations/supabase/client'

export const checkExistingOperator = async (email: string) => {
  console.log('Checking if operator already exists with email:', email)
  const { data: existingOperator, error: operatorCheckError } = await supabase
    .from('operators')
    .select('*')
    .eq('email', email)
    .maybeSingle()

  console.log('Existing operator check:', { existingOperator, operatorCheckError })
  return { existingOperator, operatorCheckError }
}

export const createOperatorProfile = async (userId: string, email: string, firstName: string, lastName: string, schoolId: string) => {
  console.log('Creating operator profile for user:', userId)
  const { data: operatorData, error: operatorError } = await supabase
    .from('operators')
    .insert({
      user_id: userId,
      school_id: schoolId,
      email: email,
      first_name: firstName,
      last_name: lastName,
    })
    .select()
    .single()

  console.log('Operator creation result:', { operatorData, operatorError })
  return { operatorData, operatorError }
}

export const verifyOperatorAccess = async (userId: string) => {
  console.log('Verifying operator access for user:', userId)
  const { data: operator, error: operatorError } = await supabase
    .from('operators')
    .select('*')
    .eq('user_id', userId)
    .single()

  console.log('Operator verification:', { operator, operatorError })
  return { operator, operatorError }
}

export const handleExistingUserSignup = async (email: string, password: string, firstName: string, lastName: string, schoolId: string) => {
  console.log('User exists in auth, checking if we should create operator profile')
  
  // Try to sign in to get the user ID
  const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword({
    email,
    password,
  })
  
  if (signInData?.user && !signInError) {
    console.log('Successfully signed in existing user, creating operator profile')
    
    // Create operator profile for existing user
    const { operatorData, operatorError } = await createOperatorProfile(
      signInData.user.id,
      email,
      firstName,
      lastName,
      schoolId
    )

    if (operatorError) {
      console.error('Failed to create operator profile for existing user:', operatorError)
      await supabase.auth.signOut()
      throw new Error(`Failed to create operator profile: ${operatorError.message}`)
    }

    console.log('Operator profile created successfully for existing user:', operatorData)
    return { success: true, message: "Your operator account has been created and you are now signed in." }
  } else {
    throw new Error('An account with this email already exists but credentials do not match')
  }
}
